import api from "./api";

export interface IDocumento {
    nombre: string;
    enlace: string;
}

export interface IDocumentosResponse {
    datos: IDocumento[];
}

/**
 * Obtiene desde backend la lista de documentos SGC con sus enlaces para la vista de Nosotros.
 *
 * Fuente funcional de los enlaces: informatica.elmejor@gmail.com
 */
export const fetchDocumentosSGC = async (): Promise<IDocumento[]> => {
    try {
        const response = await api.get<IDocumentosResponse>("/documentos-sgc");
        return response.data.datos; // Extraemos solo la lista de documentos
    } catch (error) {
        console.error("Error al obtener los documentos SGC:", error);
        throw error;
    }
};
